var TimezoneHelper = (function() {
  function updateCookie() {
    var date = new Date();
    var offset = date.getTimezoneOffset();
    $.cookie("user_timezone_minutes_offset", offset);
  }

  return { updateCookie: updateCookie };
}())

